import api from '@/store/api';

const state = {
  modalOpen: false,
  prices: null,
};

const getters = {
  modalOpen: ({ modalOpen }) => modalOpen,
  prices: ({ prices }) => prices,
};
const mutations = {
  RESET_SUBSCRIPTION_STATE: (state) => {
    state.modalOpen = false;
    state.prices = null;
  },
  UPDATE_MODAL_OPEN: (state, payload) => {
    state.modalOpen = payload;
  },
  UPDATE_PRICES: (state, payload) => {
    state.prices = payload;
  },
};

const actions = {
  fetchPrices: async ({ commit }) => {
    try {
      const pricesRequest = await api.get('/prices/');
      commit('UPDATE_PRICES', pricesRequest.data);
      commit('UPDATE_MODAL_OPEN', true);
    } catch (e) {
      commit('UPDATE_PRICES', null);
    }
  },
  openModal: ({ commit }) => {
    commit('UPDATE_MODAL_OPEN', true);
  },
  closeModal: ({ commit }) => {
    commit('UPDATE_MODAL_OPEN', false);
  },
  getSubscriptionUrl: async ({ commit }, payload) => {
    const request = typeof payload === 'object' ? payload : { period: payload };
    const { period, target = '_self' } = request;
    let invoiceWindow = null;
    if (target === '_blank') {
      invoiceWindow = window.open('', '_blank');
      if (invoiceWindow) {
        invoiceWindow.document.title = 'Orbital invoice';
        invoiceWindow.document.body.innerText = 'Creating your Orbital invoice. Please wait...';
      }
    }
    commit('UPDATE_IS_LOADING', true, { root: true });
    try {
      const response = await api.post('/create-subscription/', { period });
      if (invoiceWindow) invoiceWindow.location.replace(response.data.url);
      else window.open(response.data.url, target);
    } catch (error) {
      if (invoiceWindow) invoiceWindow.close();
      if (!error || !error.isSessionExpired) {
        commit('UPDATE_GLOBAL_ERRORS', [error.description]);
      }
    } finally {
      commit('UPDATE_IS_LOADING', false, { root: true });
    }
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
